import { HomePage } from '~/__generated_types__/globalTypes'

export const PAGES = [
  { value: HomePage.Loadboard, label: 'Load Board' },
  { value: HomePage.DriverVisibility, label: 'Driver Visibility' },
]

export const ERROR_DELAY = 15000
